<template>
  <div class="content-wrapper">
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: [
  ],
  methods: {
  },
  async mounted () {
    this.appHomeBack()
  }
}
</script>
